/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useRef, useState } from "react";
import Page from "components/common_components/Page";
import I9 from "./components/forms/immigration/I-9/I9";
import FormsContext from "./FormsContext";
import { useHistory } from "react-router-dom";
import Button from "components/common_components/Button";
import FormActions from "./form-actions";
import { hasElements } from "utils/arrays";
import { useDispatch } from "react-redux";
import { notifyError, notifySuccess } from "redux/actions/Notifications";
import Icon from "components/common_components/Icon";
import Status from "components/common_components/Status";

const AddForm = () => {
    const iframeRef = useRef(null);
    const history = useHistory();
    const dispatch = useDispatch();
    const {
        FormClients,
        addFormState: { category, form, client },
    } = useContext(FormsContext);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (!(form && client)) {
            history.push("/forms/add/wizard");
        }
    }, [form, client]);

    useEffect(() => {
        const handleIFrameEvent = (event) => {
            if (event.origin !== window.location.origin) {
                return;
            }
            console.log("Response from iframe:", event.data);

            if (!event.data || !event.data?.action) return;
            const { action } = event.data;
            switch (action) {
                case FormActions.GET_FORM_VALUES_RESPONSE:
                    const { values } = event.data;
                    submitForm(values);
                    break;

                default:
                    break;
            }
        };

        window.addEventListener("message", handleIFrameEvent);

        return () => {
            window.removeEventListener("message", handleIFrameEvent);
        };
    }, []);

    const submitForm = (values) => {
        if (form && client && hasElements(values)) {
            setIsSubmitting(true);

            const payload = {
                clientId: client.id,
                formId: form.id,
                status: "open",
                values: values.reduce((arr, mapping) => {
                    const valueObj = {
                        formClientId: null,
                        fieldMappingsId: mapping.id,
                        value: mapping.value,
                    };
                    return [...arr, valueObj];
                }, []),
            };

            FormClients.add({
                payload,
                onSuccess,
                onError,
            });
        }
    };

    const onSuccess = (newId) => {
        dispatch(notifySuccess("Form created successfully"));
        setIsSubmitting(false);
        history.push(`/forms/${newId}`);
    };

    const onError = (error) => {
        dispatch(notifyError(error.message || error));
        setIsSubmitting(false);
    };

    const loadClientInfo = () => {
        if (client) {
            iframeRef.current.contentWindow.postMessage(
                { action: FormActions.LOAD_CLIENT_INFO, client, formFieldMappings: form?.formFieldMappings },
                window.location.origin
            );
        }
    };

    const getFormValues = () => {
        iframeRef.current.contentWindow.postMessage(
            { action: FormActions.GET_FORM_VALUES, formFieldMappings: form?.formFieldMappings },
            window.location.origin
        );
    };

    const onCancelHandler = () => history.push(`/forms`);

    return (
        <Page className="add-form-page">
            <div className="form-head">
                <div className="item form-status">
                    <Status id="new" />
                </div>
                <div className="item">{category}</div>
                <div className="item">
                    <span>{form?.code}</span>
                    <span>({form?.version})</span>
                    {form?.isCurrent ? <Status id="active" /> : <Status id="oldVersion" />}
                </div>
                <div className="item">{client?.fullName}</div>
                <div className="item form-actions">
                    <Button secondary small onClick={loadClientInfo}>
                        <Icon name="client-info" size="sm" color="white" />
                        <span>Load client</span>
                    </Button>

                    <Button secondary small onClick={getFormValues} loading={isSubmitting}>
                        <Icon name="save" size="sm" color="white" />
                        <span>Save</span>
                    </Button>

                    <Button secondary outline small className="cancel" onClick={onCancelHandler}>
                        Cancel
                    </Button>
                </div>
            </div>
            <I9 ref={iframeRef} />
        </Page>
    );
};

export default AddForm;
